import React from 'react';
import { Link } from 'react-router-dom';
import colors from '../theme/colors';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col font-sans" style={{ backgroundColor: colors.bg }}>
      
      {/* 1. NAVBAR */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <span className="text-2xl font-extrabold tracking-tight" style={{ color: colors.accent }}>
              nitya<span className="text-orange-500">.ai</span>
            </span>
          </Link>

          {/* Navigation Links */}
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-700">
            {/* <div className="relative flex items-center gap-1 cursor-pointer hover:text-black">
              <span>Features</span>
              <span className="px-1.5 py-0.5 text-[10px] bg-orange-500 text-white rounded font-bold uppercase">
                New
              </span>
            </div>

            <div className="flex items-center gap-1 cursor-pointer hover:text-black">
              <span>Solutions</span>
            </div>

            <div className="relative flex items-center gap-1 cursor-pointer hover:text-black">
              <span>Pricing</span>
              <span className="px-1.5 py-0.5 text-[10px] bg-orange-500 text-white rounded font-bold uppercase">
                Update
              </span>
            </div>

            <Link to="#" className="hover:text-black">Blog</Link>
            <Link to="#" className="hover:text-black">Contact</Link>
            <span className="cursor-pointer hover:text-black">Eng 🌐</span> */}
          </nav>

          {/* Right CTA Actions */}
          <div className="flex items-center gap-4">
            <Link
              to="/retailer/login"
              className="text-sm font-medium text-gray-700 hover:text-black flex items-center gap-1"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Retailer Login
            </Link>

            {/* <Link
              to="/visualizer"
              className="px-5 py-2.5 rounded-lg text-sm font-semibold text-white transition-all shadow-sm hover:opacity-95"
              style={{ backgroundColor: colors.accent }}
            >
              Go to Visualizer
            </Link> */}
          </div>
        </div>
      </header>


      {/* 2. HERO SECTION */}
      <section className="relative overflow-hidden bg-[#dce7e5] py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 items-center gap-12">
          
          {/* Left Column Text & CTA */}
          <div className="space-y-6 z-10">
            <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight text-gray-900">
              <span style={{ color: colors.accent }}>Reimagine Your Space</span> <br />
              <span className="bg-gradient-to-r from-indigo-700 via-purple-600 to-amber-500 bg-clip-text text-transparent">
                Future of Room Visualization
              </span>
            </h1>

            <p className="text-base md:text-lg text-gray-600 max-w-lg leading-relaxed">
              AI-powered tool for multi-surface visualization – wall, flooring, rug, paint color, tiles, wallpaper, carpet, and more.
            </p>

            {/* Action Button */}
            <div>
              <Link
                to="/retailer/login"
                className="inline-flex items-center px-6 py-3.5 rounded-lg text-white font-semibold text-base transition-transform hover:-translate-y-0.5 shadow-md"
                style={{ backgroundColor: colors.accent }}
              >
                Try Our Visualizer
              </Link>
            </div>

            {/* Rating Cards */}
            {/* <div className="flex items-center gap-6 pt-4">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-red-500 text-white flex items-center justify-center font-bold text-xs shadow-sm">
                  G
                </div>
                <div>
                  <div className="text-xs font-bold text-gray-900">4.9 out of 5 stars</div>
                  <div className="text-amber-500 text-xs">★★★★★</div>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold text-xs shadow-sm">
                  C
                </div>
                <div>
                  <div className="text-xs font-bold text-gray-900">4.9 out of 5 stars</div>
                  <div className="text-amber-500 text-xs">★★★★★</div>
                </div>
              </div>
            </div> */}
          </div>

          {/* Right Column Illustration Image Placeholder */}
          <div className="relative flex justify-center items-center">
            <img
              src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&w=1000&q=80"
              alt="Room Visualization Banner"
              className="rounded-2xl shadow-2xl object-cover w-full max-w-lg h-[420px]"
            />
          </div>
        </div>
      </section>


      {/* 3. CTA BANNER */}
      <section className="py-12" style={{ backgroundColor: colors.accent }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
          <div>
            <h2 className="text-2xl md:text-4xl font-extrabold text-white">
              Ready to upgrade your <br />
              <span className="text-orange-400">wall & flooring experience?</span>
            </h2>
          </div>

          <div className="flex flex-col items-center gap-2">
            <Link
              to="/retailer/login"
              className="px-8 py-3.5 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-lg transition-colors shadow-md text-base"
            >
              Try for free
            </Link>
            <span className="text-xs text-gray-400">No credit card required.</span>
          </div>
        </div>
      </section>


      {/* 4. FOOTER */}
      <footer className="text-gray-300 py-16 mt-auto border-t border-gray-800" style={{ backgroundColor: colors.accent }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-5 gap-8 text-xs">
          
          {/* Features Column */}
          <div className="space-y-3">
            <h4 className="font-bold text-white uppercase text-sm mb-4">Features</h4>
            <p className="hover:text-white cursor-pointer">Visualizer</p>
            <p className="hover:text-white cursor-pointer flex items-center gap-1">
              360 Panorama <span className="text-[9px] bg-orange-500 text-white px-1 rounded">NEW</span>
            </p>
            <p className="hover:text-white cursor-pointer">Generate Catalog PDF</p>
            <p className="hover:text-white cursor-pointer">Website Integration</p>
            <p className="hover:text-white cursor-pointer">Room Photo to Visualizer</p>
            <p className="hover:text-white cursor-pointer">Showroom Kiosk</p>
            <p className="hover:text-white cursor-pointer">QR Visualizer Links</p>
          </div>

          {/* Materials Column */}
          <div className="space-y-3">
            <h4 className="font-bold text-white uppercase text-sm mb-4">Materials</h4>
            <p className="hover:text-white cursor-pointer">Tiles</p>
            <p className="hover:text-white cursor-pointer">Marble, Granite</p>
            <p className="hover:text-white cursor-pointer">Stone, Quartz</p>
            <p className="hover:text-white cursor-pointer">Wooden Flooring</p>
            <p className="hover:text-white cursor-pointer">Wallpaper</p>
            <p className="hover:text-white cursor-pointer">Wall Panel</p>
            <p className="hover:text-white cursor-pointer">Paint</p>
            <p className="hover:text-white cursor-pointer">Rug / Carpet Tile</p>
          </div>

          {/* Solutions Column */}
          <div className="space-y-3">
            <h4 className="font-bold text-white uppercase text-sm mb-4">Solutions</h4>
            <p className="hover:text-white cursor-pointer">Manufacturing Industry</p>
            <p className="hover:text-white cursor-pointer">Distributors / Wholesalers</p>
            <p className="hover:text-white cursor-pointer">Offline Retailer</p>
            <p className="hover:text-white cursor-pointer">E-Commerce</p>
            <p className="hover:text-white cursor-pointer">Enterprise Company</p>
            <p className="hover:text-white cursor-pointer">Tiles Designer</p>
          </div>

          {/* Resources Column */}
          <div className="space-y-3">
            <h4 className="font-bold text-white uppercase text-sm mb-4">Resources</h4>
            <p className="hover:text-white cursor-pointer">Blog</p>
            <p className="hover:text-white cursor-pointer">Case Study</p>
            <p className="hover:text-white cursor-pointer">Video Guide</p>
            <p className="hover:text-white cursor-pointer">What's New</p>
            <p className="hover:text-white cursor-pointer">Payment & Refund</p>
            <p className="hover:text-white cursor-pointer">F.A.Q</p>
          </div>

          {/* Company Column */}
          <div className="space-y-3">
            <h4 className="font-bold text-white uppercase text-sm mb-4">Company</h4>
            <p className="hover:text-white cursor-pointer">About Us</p>
            <p className="hover:text-white cursor-pointer flex items-center gap-1">
              Careers <span className="text-[9px] bg-emerald-500 text-white px-1 rounded">We're hiring!</span>
            </p>
            <p className="hover:text-white cursor-pointer">Plan & Subscription</p>
            <p className="hover:text-white cursor-pointer flex items-center gap-1">
              Affiliate Partners <span className="text-[9px] bg-sky-500 text-white px-1 rounded">Reseller</span>
            </p>
            <p className="hover:text-white cursor-pointer">Contact Us</p>
          </div>

        </div>
      </footer>

    </div>
  );
}
